export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7547.1d551a1c.jpg";